import React from 'react';
import classnames from 'classnames';

import { ComponentPropsWithoutRef } from '../../types/utils';

export type HeadingOwnProps = {
  level?: 1 | 2 | 3 | 4 | 5 | 6;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'default' | 'teal' | 'danger' | 'success' | 'dark';
  weight?: 'normal' | 'medium';
};

export type HeadingProps = ComponentPropsWithoutRef<'h1'> & HeadingOwnProps;

export const Heading: React.FC<HeadingProps> = ({
  level = 1,
  size = 'lg',
  variant = 'default',
  weight = 'medium',
  className,
  children,
  ...rest
}) => {
  const classNames = classnames(
    'tracking-wide',
    {
      'font-normal': weight === 'normal',
      'font-medium': weight === 'medium',
    },
    {
      'text-teal-500': variant === 'teal',
      'text-red-700': variant === 'danger',
      'text-emerald-700': variant === 'success',
      'text-gray-900': variant === 'dark',
    },
    {
      'text-3xl': size === 'xl',
      'text-2xl': size === 'lg',
      'text-xl': size === 'md',
      'text-lg': size === 'sm',
    },
    className
  );

  return React.createElement(`h${level}`, {
    children: children,
    className: classNames,
    ...rest,
  });
};
